import PropTypes from "prop-types";
import DestinationPicker from "components/AsyncSelect/DestinationPicker";

const AttractionDestinationEditComponent = (props) => {
  const { rowData, onChange, formSchemaField } = props;
  const rawDestination = rowData.destinations && rowData.destinations[0];
  const selectedDestForPicker = rawDestination
    ? {
        label: rawDestination.destinationName,
        value: rawDestination._id,
        ...rawDestination,
      }
    : {};

  return (
    <DestinationPicker
      destination={formSchemaField} // Use prop
      selectedDestination={selectedDestForPicker}
      handleChange={(value) => {
        onChange(value);
      }}
    />
  );
};

export default AttractionDestinationEditComponent;

AttractionDestinationEditComponent.propTypes = {
  rowData: PropTypes.shape({
    destinations: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string, // Or PropTypes.any if it can vary
        destinationName: PropTypes.string,
        // Add other expected properties of a destination object if known/needed for validation
      })
    ),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  formSchemaField: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    errorMsg: PropTypes.string,
    invalidMsg: PropTypes.string,
    // Add other specific fields from your destination schema if needed
  }).isRequired,
};
